<div class="relative size-6 xl:size-10">
  <button mat-icon-button id="notification-btn" [matMenuTriggerFor]="notificationMenu">
    <mat-icon class="material-icons-outlined">notifications</mat-icon>
  </button>

  @if (numOfUnread > 0) {
    <span
      class="absolute right-0 top-0 size-2 -translate-x-0.5 -translate-y-0.5 transform rounded-full bg-red-500 text-center text-xs text-white xl:size-4"
      data-cy="notification-unread-badge"
    >
    </span>
  }
</div>

<mat-menu #notificationMenu="matMenu" class="h-[304px] w-[329px] !min-w-0 !max-w-[unset]">
  <!-- eslint-disable-next-line -->
  <div class="flex flex-col" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-4 py-2">
      <span class="text-[16px] font-semibold leading-5">{{ 'notification.notification' | translate }}</span>
      <div class="flex items-center space-x-2">
        <button id="read-all-btn" mat-button (click)="markAsRead()">
          {{ 'notification.mark-all-as-read' | translate }}
        </button>
      </div>
    </div>
    <div class="h-px w-full bg-gray-300"></div>
    <div class="flex-1 overflow-y-auto">
      @for (notification of notifications; track notification._id; let index = $index) {
        <button
          class="w-full cursor-pointer border-b border-gray-200 hover:bg-gray-100"
          [attr.data-cy]="'notification-item-' + index"
          (click)="onNotificationClick(notification, index)"
        >
          <div
            class="justify-left flex w-full flex-col items-start space-y-1 px-4 py-2"
            [attr.data-cy]="
              notification.status === NotificationStatus.Unread ? 'notification-item-unread' : 'notification-item-read'
            "
            [ngClass]="{
              'text-gray-600': notification.status === NotificationStatus.Read,
              'border-l-4 border-primary': notification.status === NotificationStatus.Unread,
            }"
          >
            <span class="text-sm font-medium leading-none">
              {{ notification.title }}
            </span>
            <span class="text-left text-[14px] leading-[14px]">
              {{ notification.message }}
            </span>
            <span class="ml-auto text-xs">
              {{ notification.timestamp | date: 'dd-MM-YYYY hh:mm a' }}
            </span>
          </div>
        </button>
      }
    </div>
  </div>
</mat-menu>
